import { Injectable, inject } from '@angular/core';
import { NotificationService as KendoNotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationService = inject(KendoNotificationService);


  showSuccess(message: string, title?: string): void {
    this.notificationService.show({
      content: title ? `${title}: ${message}` : message,
      cssClass: 'button-notification',
      animation: { type: 'slide', duration: 400 },
      position: { horizontal: 'right', vertical: 'top' },
      type: { style: 'success', icon: true },
      hideAfter: 3000,
    });
  }

  showError(message: string, title?: string): void {
    this.notificationService.show({
      content: title ? `${title}: ${message}` : message,
      cssClass: 'button-notification',
      animation: { type: 'slide', duration: 400 },
      position: { horizontal: 'right', vertical: 'top' },
      type: { style: 'error', icon: true },
      hideAfter: 5000,
    });
  }

  showWarning(message: string, title?: string): void {
    this.notificationService.show({
      content: title ? `${title}: ${message}` : message,
      cssClass: 'button-notification',
      animation: { type: 'slide', duration: 400 },
      position: { horizontal: 'right', vertical: 'top' },
      type: { style: 'warning', icon: true },
      hideAfter: 4000,
    });
  }

  showInfo(message: string, title?: string): void {
    this.notificationService.show({
      content: title ? `${title}: ${message}` : message,
      cssClass: 'button-notification',
      animation: { type: 'slide', duration: 400 },
      position: { horizontal: 'right', vertical: 'top' },
      type: { style: 'info', icon: true },
      hideAfter: 3000,
    });
  }
}
